import React, { ReactElement, useCallback, useEffect, useMemo, useState } from 'react';
import { Video } from '../importCL';
import axios from 'axios';
import { useApiTokenContext } from '../providers/ApiTokenProvider/ApiTokenProvider';
import SessionStorage from '../utils/SessionStorage';
import { findVideoId, initialiseSingleVideoData, YoutubeConstants } from '../utils/youtube-utils/youtube-utils';
import { YoutubeVideo } from '../utils/youtube-utils/YoutubeTypes/YoutubeTypes';

export interface ISingleYoutubeVideoProps {
    youtubeUrl: string,
}

const useSingleYoutubeVideo = (props: ISingleYoutubeVideoProps) => {
    const { getTokenString } = useApiTokenContext();
    const [ fetchedUrl, setFetchedUrl ] = useState<String>('');
    const [ videoData, setVideoData ] = useState<YoutubeVideo>();

    useEffect(() => {
        if (
            !props.youtubeUrl
            || findVideoId(props.youtubeUrl)?.length !== 2
            || (fetchedUrl && fetchedUrl === props.youtubeUrl)
            || !getTokenString('youtubeKey')
        ) {
            return;
        }
        const foundVideoId = findVideoId(props.youtubeUrl);

        if (!videoData) {
            if (SessionStorage.verifyNotEmpty(YoutubeConstants.storageKey)) {
                const cachedVideoData = SessionStorage.getObject(YoutubeConstants.storageKey);

                if (cachedVideoData && cachedVideoData[foundVideoId[1]]) {
                    setVideoData(cachedVideoData[foundVideoId[1]]);
                    return;
                }
            }
            initialiseSingleVideoData(foundVideoId[1], getTokenString('youtubeKey'))
                .then((videoData) => {
                    setVideoData(videoData);
                    setFetchedUrl(props.youtubeUrl);
                });
        }
    }, [props]);

    const VideoElement = useCallback((elementProps: {
        titleFallback?: string;
        descriptionFallback?: string;
        uploadDateFallback?: string;
        thumbnailOverride?: string;

        videoAltText?: string;

        frameHeight?: number;
        frameWidth?: number;
        videoDisclaimer?: ReactElement | ReactElement[] | JSX.Element;
    }) => (findVideoId(props.youtubeUrl)?.length === 2) ? (
        <Video 
            youtubeEmbedURL={props.youtubeUrl}
            title={videoData?.snippet?.title || elementProps?.titleFallback || ''}

            metaThumbnailURL={elementProps.thumbnailOverride || `https://img.youtube.com/vi/${findVideoId(props.youtubeUrl)[1]}/hqdefault.jpg`}
            metaDescription={videoData?.snippet?.description || elementProps?.descriptionFallback || ''}
            metaUploadDate={videoData?.snippet?.publishedAt || elementProps?.uploadDateFallback || ''}

            frameWidth={elementProps?.frameWidth}
            frameHeight={elementProps?.frameHeight}
            altText={elementProps?.videoAltText}
            videoDisclaimer={elementProps?.videoDisclaimer}
        />
    ) : null
    , [videoData]);

    return {
        VideoElement,
        videoData,
    };
};

export default useSingleYoutubeVideo;